import { useContext } from 'react';
import { DrawerContext } from '../context';

export function useDrawer() {
  const context = useContext(DrawerContext);

  return context;
}
